export const texts = {
    PAGE_TITLE: 'Acceso con usuario registrado'
}

export const objComponentFormio = {    
    aliasFormulario: 'accesoConContrasena',
    sp: {
        complete: 'Formulario cumplimentado correctamente',
        error: 'Hubo un problema',
        next: 'Siguiente',
        previous: 'Atrás',
        cancel: 'Cancelar',
        submit: 'Guardar',
        required: 'Es obligatorio rellenar este campo',
        confirmCancel: '¿Estás seguro que quieres cancelar?',
        submitError: 'Por favor revise el formulario y corrija todos los errores.',
        pattern: 'El valor no cumple con el patrón requerido',
        email: 'Debe ser una dirección de correo electrónico válida',
        invalid_regex: 'El valor insertado no es válido'
    }
}

export const cruds = {
    loginRequest: {
        resource: 'login-usuario',
        url: '/login'
    },
    interesado: {
        resource: 'interesado'
    },
    validacion: {
        resource: 'validacion',
        url: 'registrar-credencial'
    },
}

export const datosLogin = {
    usuario: '',
    contrasena: ''
}

export const properties = {
    TIPO_AUTENTICACION_REGISTRADO: 'ur',
    TIPO_CRE_FACHADA: 'fa'
}